<template>
    <rkm-overlay>
        <rkm-layout-body title="Assinatura eletrônica">

            <rkm-layout-content v-if="loaded">
                <List
                    :data="{ form }"
                    ref="List"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/assinatura-eletronica/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            assinatura: this.getConectaSusRepository('exameLaboratorial.assinaturaEletronica')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.assinatura.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, object, data]
}
</script>